<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @search="search" @reflash="reflash" @exps="exps" ref="SetBtn"></buttonlist>
		<div style="margin-top: 2px">
			<el-button type="primary" size="mini" @click="getPrice" :disabled="dataSet.length < 1">{{$t('getapi[13412]')}}</el-button>
			<el-button type="primary" size="mini" @click="clearData">{{$t('getapi[2026]')}}</el-button>
			<el-button type="primary" size="mini" @click="saveData">{{$t('getapi[937]')}}</el-button>
			<el-select filterable v-model="type" size="mini" @change="changeType" style="float: right">
				<el-option key="1" :label="$t('getapi[13411]')" value='1'></el-option>
				<el-option key="2" :label="$t('getapi[13410]')" value='2'></el-option>
				<el-option key="3" :label="$t('getapi[13409]')" value='3'></el-option>
			</el-select>
		</div>
		<el-table
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			style="width: 100%; margin-top:0px"
			:header-cell-style="$limits.headerClass"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Create_Date" :label="$t('getapi[1859]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Order_No" :label="$t('getapi[1925]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Part_code" :label="$t('getapi[112]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Part_version" :label="$t('getapi[116]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Pur_Measure" :label="$t('getapi[1166]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Category_first" :label="$t('getapi[169]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Category_second" :label="$t('getapi[170]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Category_third" :label="$t('getapi[171]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Part_model" :label="$t('getapi[124]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Part_spec" :label="$t('getapi[125]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Vender_code" :label="$t('getapi[1196]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Pur_Measure_Actually_qty" :label="$t('getapi[1877]')" align="right">
				<template scope="scope" >
					<el-input v-model="scope.row.Pur_Measure_Actually_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" @change="changeQtyOrPrice(scope)"></el-input>
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="Unit_price" :label="$t('getapi[1410]')" align="right" >
				<template scope="scope" >
					<el-input v-model="scope.row.Unit_price" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" @change="changeQtyOrPrice(scope)"></el-input>
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="Line_Total_Amount" :label="$t('getapi[1881]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Batch_No" :label="$t('getapi[1763]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Sequence_No" :label="$t('getapi[1764]')"></el-table-column>
		</el-table>
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="pageSize"
					:pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<serce :isVisible="isVisible" queryData="EstimateInput" ref="ser" @getser="serclick"></serce>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'3_estimateinput',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3 - Common.reduceTableHeight3,
                maxHeight: this.$windowSize.tableHeight3 - Common.reduceTableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3 - Common.reduceTableHeight3
        }
    },
	data() {
		return {
            tableHeader:[],
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('3_estimateinput'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
            scrollTop:0,
            type:'1',//1:上次入库成本2:上次出库成本3:结存成本
		};
	},
	mounted: function() {
		let that = this;
        that.colsort();
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        colsort() {
            let that = this;
            that.$loadviewfields.Fileds('EstimateInput', 0, PFileds => {
                that.tableHeader = PFileds;
            });
        },
        sortclick(val) {
            if (val == 1) {
                this.colsort();
            }
        },
        // 修改表格顺序
        opentable() {
            this.$refs.ctab.clearInputs(true);
        },
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[959]"),this.$t("getapi[16]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetButtonEnable('search');
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('3_estimateinput',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'EstimateInput');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('/GL/Cost/GetEstimateInput', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
					that.authority();
				}
			});
		},
		//修改数量
        changeQtyOrPrice(row){
            let that = this
			let index = row.$index
			console.log(index)
			that.dataSet[index].Line_Total_Amount = that.dataSet[index].Pur_Measure_Actually_qty * that.dataSet[index].Unit_price
		},
		// 取数
        getPrice() {
			let that = this;
			let arr = []
			for(let i=0;i<that.dataSet.length;i++){
                arr = [...arr,{
                    Order_No: that.dataSet[i].Order_No,
                    Part_code: that.dataSet[i].Part_code,
                    Part_version : that.dataSet[i].Part_version
				}]
			}
			let parm = {
			    type : that.type,
				list : arr
			}
            that.$http.urlpost('/GL/Cost/DataRetrieval', parm, function(res) {
                if (res.Success == 1) {
                    let arr = res.DataContent;
                    for(let i=0;i<arr.length;i++){
                        for(let j=0;j<that.dataSet.length;j++){
                            if(arr[i].Part_code == that.dataSet[j].Part_code && arr[i].Part_version == that.dataSet[j].Part_version){
                                that.dataSet[j].Unit_price = (arr[i].unit_price == 0 ? '':arr[i].unit_price)
								if(that.dataSet[j].Unit_price != ''){
                                    that.dataSet[j].Line_Total_Amount = that.dataSet[j].Pur_Measure_Actually_qty * that.dataSet[j].Unit_price
								} else{
                                    that.dataSet[j].Line_Total_Amount = ''
								}
							}
						}
					}
                }
            });
		},
		//清空
        clearData(){
            let that = this
			that.dataSet = []
		},
		//保存数据
        saveData(){
            let that = this
            let arr = []
            for(let i=0;i<that.dataSet.length;i++){
                arr = [...arr,{
                    Order_No: that.dataSet[i].Order_No,
                    Part_code: that.dataSet[i].Part_code,
                    Part_version : that.dataSet[i].Part_version,
                    Total_Amount: that.dataSet[i].Line_Total_Amount
                }]
            }
            let parm = arr
            that.$http.urlpost('/GL/Cost/saveEstimateinput', parm, function(res) {
                if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                }
            });
		},
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
